import { Card, FormatDate, InformationalLegends } from '@wyz/ui';
import { DateUtils } from '@wyz/utils';
import * as React from 'react';
import { Trans, useLocale } from '~/common/context';
import type { IContainerOrder } from '~/common/types';

interface OrderDatesCardProps {
  order: Pick<
    IContainerOrder,
    | 'orderedAt'
    | 'updatedAt'
    | 'expectedDeliveryDate'
    | 'createdAt'
    | 'multiDateDelivery'
    | 'resolvedDeliveryDate'
  >;
}

const OrderDatesCard: React.FC<OrderDatesCardProps> = ({ order }) => {
  const locale = useLocale();

  return (
    <Card className='h-100'>
      <Card.Body className='space-y-2'>
        <InformationalLegends.Container>
          <InformationalLegends.Row>
            <InformationalLegends.Label>
              <Trans i18nKey='app.purchase.orders.table.order_date' />
            </InformationalLegends.Label>
            <InformationalLegends.Value id='ordered-at'>
              <FormatDate
                date={order.orderedAt}
                format={DateUtils.DATE_FORMAT.DMY}
                locale={locale.locale}
              />
            </InformationalLegends.Value>
          </InformationalLegends.Row>
          <InformationalLegends.Row>
            <InformationalLegends.Label>
              <Trans i18nKey='app.container.order.detail.last_update' />
            </InformationalLegends.Label>
            <InformationalLegends.Value id='delivered-at'>
              {order.updatedAt !== order.createdAt ? (
                <FormatDate
                  date={order.updatedAt}
                  format={DateUtils.DATE_FORMAT.DMY}
                  locale={locale.locale}
                />
              ) : (
                '-'
              )}
            </InformationalLegends.Value>
          </InformationalLegends.Row>
          <InformationalLegends.Row>
            <InformationalLegends.Label>
              <Trans i18nKey='app.purchase.orders.table.delivery_date' />
            </InformationalLegends.Label>
            <InformationalLegends.Value id='delivered-at'>
              {order.multiDateDelivery ? (
                <Trans i18nKey='app.container.order.detail.multi_date_delivery' />
              ) : (
                <FormatDate
                  date={
                    order.resolvedDeliveryDate ?? order.expectedDeliveryDate
                  }
                  format={DateUtils.DATE_FORMAT.DMY}
                  locale={locale.locale}
                />
              )}
            </InformationalLegends.Value>
          </InformationalLegends.Row>
        </InformationalLegends.Container>
      </Card.Body>
    </Card>
  );
};

export default OrderDatesCard;
